<ng-container *ngIf="!edit; else editing">
    <kw-fill-layer-renderer [fillClass]="gridCell.fillClass" [fillColor]="gridCell.fillColor"></kw-fill-layer-renderer>
    <div class="content-layer">
        <div *ngFor="let contentElement of gridCell.contentElements" class="content-element-container">
            <kw-content-element-renderer [contentElement]="contentElement" [contentElements]="gridCell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
        </div>
    </div>
</ng-container>
<ng-template #editing>
    <ng-container *ngIf="gridCell.status === 'Initial Draft';else inProgress">
        <kw-fill-layer-renderer [fillClass]="gridCell.fillClass" [fillColor]="gridCell.fillColor"></kw-fill-layer-renderer>
        <div class="content-layer">
            <div *ngFor="let contentElement of gridCell.contentElements" class="content-element-container">
                <kw-content-element-renderer [contentElement]="contentElement" [contentElements]="gridCell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
            </div>
        </div>
    </ng-container>
    <ng-template #inProgress>
        <kw-edit-placeholder-renderer [gridCell]="gridCell" (createGridCellContent)="createContent($event)"></kw-edit-placeholder-renderer>
    </ng-template>
</ng-template>

